module.exports = __webpack_public_path__ + "img/corpuls_aed.470bdb13.png";